import React from 'react';
import * as PT from "../global/PortalTools";

// Tlačidlá ±1 okolo existujúceho poľa množstva (téma v2). Vracia fragment bez obaľovacieho
// elementu, takže v téme v1 (tlačidlá sú skryté cez .v2-only) sa štruktúra .input-group nemení.
// Tlačidlá majú type="button" a vlastný handler, nikdy neposielajú event do PT.addToBasket.
export function nextAmount(current, delta) {
    let value = Number(current);
    if (isNaN(value)) {
        value = 1;
    }
    return Math.max(1, value + delta);
}

// ±1 v košíku (Basket, TopBasket): kliky idú postupne, každý z množstva po predchádzajúcom.
// Pri persist_cart čaká changeAmountInBasket na server (GET_PORTAL_CART + UPDATE_PORTAL_CART), rýchle kliky
// by inak čítali rovnaké staré množstvo (stratené kliky) a zápisy košíka by mohli prísť v inom poradí.
let basketSteps = Promise.resolve();

export function stepBasketAmount(index, delta) {
    basketSteps = basketSteps.then(() => {
        let item = window.basket && window.basket.items[index];
        if (item) {
            return PT.changeAmountInBasket(index, nextAmount(item.amount, delta));
        }
    }).catch((error) => console.error(error));
    return basketSteps;
}

export default function AmountStepper({onStep, disabled, children}) {
    return (
        <React.Fragment>
            <button type="button" className="stepper-btn stepper-minus v2-only" tabIndex={-1} aria-label="-1"
                    disabled={disabled} onClick={() => onStep(-1)}>
                <i className="icon-minus3"/>
            </button>
            {children}
            <button type="button" className="stepper-btn stepper-plus v2-only" tabIndex={-1} aria-label="+1"
                    disabled={disabled} onClick={() => onStep(1)}>
                <i className="icon-plus3"/>
            </button>
        </React.Fragment>
    );
}
